import React from "react";
import "./Footer.css"

function Footerg(){
  return(
    <div id="footersection">
        <div id="bigfooter">
                    
                    <div>
                        <h3>Main Stories</h3>
                        <hr className="bigfoothr"/>
                        <ul>
                            <li><a href="">MAGAZINE</a></li>
                            <li><a href="">NATIONAL</a></li>
                            <li><a href="">INTERNATIONAL</a></li>
                            <li><a href="">BUSINESS</a></li>
                            <li><a href="">OPINIONS</a></li>
                            <li><a href="">BOOK REVIES </a></li>
                            <li><a href="">THE NEWS  </a></li>
                            <li><a href="">SPORTS </a></li>
                            <li><a href="">ART & ENTERTAINMENT</a></li>
                        </ul>
                    </div>
                    
                    <div>
                        <h3>Traveller</h3>
                        <hr className="bigfoothr"/>
                        <ul>
                            <li><a href="">TRAVELOGUES</a></li>
                            <li><a href="">WEEKENDS BREAKS</a></li>
                            <li><a href="">HOLIDAYS WITH OT</a></li>
                            <li><a href="">PHOTO FEATURES</a></li>
                            <li><a href="">HOTELS </a></li>
                            <li><a href="">GUIDEBOOKS</a></li> 
                        </ul>
                    </div>
                  
                    <div>
                        <h3>Money</h3>
                        <hr className="bigfoothr"/>
                        <ul>
                            <li><a href="">Mutual Funds</a></li>
                            <li><a href="">Insurance</a></li>
                            <li><a href="">Enquity</a></li>
                            <li><a href="">Fixed Assets</a></li>
                            <li><a href="">Banking </a></li>
                            <li><a href="">ASK</a></li>
                        </ul>
                    </div>
                  
                    <div>
                        <h3>Business</h3>
                        <hr className="bigfoothr"/>
                        <ul>
                            <li><a href="">THE BIG STORY</a></li>
                            <li><a href="">SPECIALS</a></li>
                            <li><a href="">PERSPECTIVE</a></li>
                            <li><a href="">PIX STORY</a></li>
                            <li><a href="">ENTERPRISE</a></li>
                            <li><a href="">STRATEGY</a></li>
                            <li><a href="">MARKETS</a></li>
                            <li><a href="">CEST LA VIE</a></li>
                           
                        </ul>
                    </div>
                  
                    <div>
                        <h3>Social Media</h3>
                        <hr className="bigfoothr"/>
                        <ul>
                            <li><a href="">Facebook </a></li>
                            <li><a href="">Twitter </a></li>
                            <li><a href="">Instagram </a></li>
                            <li><a href="">Youtube </a></li>     
                        </ul>
                    </div>
                    
                  </div>
                  
                  
                  
                  <div id="smallfooter">
                    <div>
                        <a href="">About Us</a>
                        <a href="">Contact Us</a>
                        <a href="">Subscribe</a>
                        <a href="">Copyright & Disclaimer</a>
                        <a href="">Osm Awards</a>
                        <a href="">Compliences</a>
                        <a href="">Poshan</a>
                    </div>
                  
                          <div id="link">
                          <a href="">@2022 Outlook Publishing India Pvt.Ltd</a>
                         </div>
                  </div>

    </div>  
    )
}
export default Footerg